/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var ClickToDummyEngagementAnchorView = require("personalization-web-agent-views/ClickToDummyEngagementAnchorView");

    var ClickToDummyEngagementController={};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        ClickToDummyEngagementController = BaseFeatureController.extend({

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "ClickToDummyEngagementController:initialize");
            },

            onClose: function () {
                LEPersonalization.logger.info("closing", "ClickToDummyEngagementController:onClose");
            },

            /************************** Public functions *****************************************************/
            getAnchorView:function(options){
                LEPersonalization.logger.info("getAnchorView", "ClickToDummyEngagementController:getAnchorView");
                return new ClickToDummyEngagementAnchorView(options);
            },

            getAnchorModel:function(){
                return new (Backbone.Model.extend({}))();
            }
        });
    });
    return ClickToDummyEngagementController;
});
